import { all, takeLatest, call } from "redux-saga/effects";

import {
  validateLeadsterPlusMenuAccessService,
} from "../../../service/leadsterplus.service";

function* validateLeadsterPlusMenuAccess({ payload }) {
  try {
    const response = yield call(
      validateLeadsterPlusMenuAccessService, payload.params);

    if (response.status === 200) {
      payload.callbackSuccess();
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

export default all([
  takeLatest("VALIDATE_LEADSTER_PLUS_MENU_ACCESS", validateLeadsterPlusMenuAccess),
]);